import type { Translate } from "./labels";

/** A message for a failed report call; never shows server details. */
export function reportErrorMessage(t: Translate, error: unknown): string {
  const response = (error as { response?: { status?: number; data?: unknown } })?.response;
  const status = response?.status;
  const text = JSON.stringify(response?.data ?? "");
  if (status === 403 && text.includes("Only the maker")) {
    return String(t("reports.builder.errors.not_owner", {
      defaultValue: "Only the maker can change this report. Make a copy to adjust it.",
    }));
  }
  if (status === 403) {
    return String(t("reports.builder.errors.forbidden", {
      defaultValue: "This report uses data you do not have access to. Remove those parts or make a copy and adjust it.",
    }));
  }
  if (status === 404) {
    return String(t("reports.builder.errors.not_found", { defaultValue: "This report does not exist (anymore)." }));
  }
  if (status === 422 && text.includes("REPORT_TOO_SLOW")) {
    return String(t("reports.builder.errors.too_slow", {
      defaultValue: "This report takes too long. Try fewer data or more conditions.",
    }));
  }
  if (status === 422 && text.includes("REPORT_TOO_LARGE")) {
    return String(t("reports.builder.errors.too_large", {
      defaultValue: "This report has more than 10,000 rows. Add a condition to export or print it.",
    }));
  }
  if (status === 400) {
    return String(t("reports.builder.errors.invalid", {
      defaultValue: "The report could not be run. Check the columns and conditions.",
    }));
  }
  return String(t("reports.builder.errors.generic", { defaultValue: "Something went wrong. Please try again." }));
}
